import axios from "@/utils/request.js";
import qs from "qs"

// 获取最热列表
export const interactiveqaHotpage = (params) => axios({
    url: "/api/web-operate/platform/interactiveqa/hotpage",
    method: 'get',
    params
})

// 获取提问互动列表
export const interactiveqaPage = (params) => axios({
    url: "/api/web-operate/platform/interactiveqa/page",
    method: 'get',
    params
})
// 获取回复互动列表
export const interactiveqaPagereply = (params) => axios({
    url: "/api/web-operate/platform/interactiveqa/pagereply",
    method: 'get',
    params
})

// 获取问答详情
export const interactiveqaDetail= (params) => axios({
    url: "/api/web-operate/platform/interactiveqa/detail",
    method: 'get',
    params
})
// 获取回复详情
export const interactiveqaDetailreply= (params) => axios({
    url: "/api/web-operate/platform/interactiveqa/detailreply",
    method: 'get',
    params
})
// 添加提问
export const interactiveqaAdd = (params) => axios({
    url: "/api/web-operate/platform/interactiveqa/add",
    method: 'post',
    data:params
})
// 回复问题
export const interactiveqaReply = (params) => axios({
    url: "/api/web-operate/platform/interactiveqa/reply",
    method: 'post',
    Headers:{
        token:localStorage.getItem('token')
    },
    data:params
})
